import { ChangeDetectorRef, Component, computed, EventEmitter, Input, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ColumnList, ColumnPreference, Columns } from 'src/app/shared/models/column-preference';
import { ErrorMessage, ErrorType } from '../../entity/error.const';
@Component({
    selector: 'app-column-visibility',
    templateUrl: './column-visibility.component.html',
    styleUrls: ['../../css/primeng-multiselect.component.scss', '../../css/primeng-dropdown.component.scss'],
    standalone: false
})
export class ColumnVisibilityComponent implements OnDestroy, OnInit{

  selectedList:string = '';
  columnList: ColumnPreference[] = [];
  showColumnSetting: boolean = false;
  targetColumnList = signal<ColumnList[]>([])
  sourceColumnList = signal<ColumnList[]>([])
  @Input()
  set ColumnListValue(val: ColumnPreference[]) {
    this.columnList = val;
  }

  @Input()
  set selectedColumnListValue(val: ColumnPreference) {
    if(val) {
      this.selectedList = val.id;
    }
    this.setColumnSettingValue(val);
  }

  @Output() handleColumnListChange = new EventEmitter<{ 
    selectedList: ColumnPreference, tempUpdate?:boolean
  }>();
  
  constructor(
    private readonly messageService: MessageService
  ){
    document.documentElement.style.setProperty('--picklist-offset', `500px`);
  }

  OnListUpdation($event:any) {
    this.sourceColumnList.set([...$event.source]);
    this.targetColumnList.set([...$event.target]);
  }

  ngOnInit(): void {
  }

  /**
   * 
   */
  setColumnSettingValue(preference: ColumnPreference) {
    if(preference) {
      this.sourceColumnList.set(
      preference?.columnList?.filter((column: ColumnList) => !column.enable)
      );
      this.targetColumnList.set(
        preference?.columnList?.filter((column: ColumnList) => column.enable)
      );
    }
  }

  /**
   * 
   */
  updateColumnConfiguration() {
    if(this.targetColumnList().length){
      const columnList = computed<Columns>(() => {
        const source = this.sourceColumnList().map((col) => ({
          ...col,
          enable: false,
        }));

        const target = this.targetColumnList().map((col) => ({
          ...col,
          enable: true,
        }));

        return [...target, ...source];
      });
      const selectedPref:ColumnPreference = this.columnList.find(c => c.id === this.selectedList)?? {} as ColumnPreference;
      const selectedList = {
        name: selectedPref?.name,
        id: selectedPref?.id,
        columnList: columnList(),
        createdDate: selectedPref?.createdDate,
        description: selectedPref?.description,
        type:selectedPref?.type
      }
      this.handleColumnListChange.emit({
        selectedList: selectedList,
        tempUpdate: true
      })
      this.showColumnSetting = !this.showColumnSetting;
    } else {
      this.messageService.add({
        severity: ErrorType.ERROR,
        closable: false,
        summary: "Error",
        detail:ErrorMessage.COLUMNVISIBILITYERROR,
      });
    }
  }

  /**
   * 
   */
  handleUpdateColumnFilterChange($event:any) {
    const preference:ColumnPreference = this.columnList.find(c => c.id === $event.value)?? {} as ColumnPreference;
    this.setColumnSettingValue(preference)
    this.handleColumnListChange.emit({selectedList:preference});
  }

  ngOnDestroy(): void {
    // this.selectedList = {} as ColumnPreference;
    this.columnList = [];
    this.targetColumnList.set([]);
    this.sourceColumnList.set([]);
  }
}
